import React, { useEffect } from 'react';
type SEOConfig = {
  title: string;
  description: string;
  image?: string;
  path?: string;
};
type JsonLdProps = {
  data: Record<string, unknown> | Array<Record<string, unknown>>;
};
const SITE_NAME = '206Gravel';
const DEFAULT_IMAGE = 'https://cdn.magicpatterns.com/uploads/eghevqpM2SdfKP6Caac4jm/file_000000008aac723095504e05a889ad89.png';
export function useSEO({
  title,
  description,
  image = DEFAULT_IMAGE,
  path
}: SEOConfig) {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const canonicalUrl = getCanonicalUrl(path);
    document.title = title;
    setMetaTag('description', description);
    setMetaTag('og:title', title, 'property');
    setMetaTag('og:description', description, 'property');
    setMetaTag('og:image', image, 'property');
    setMetaTag('og:url', canonicalUrl, 'property');
    setMetaTag('og:type', 'website', 'property');
    setMetaTag('og:site_name', SITE_NAME, 'property');
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', image);
    setCanonical(canonicalUrl);
  }, [description, image, path, title]);
}
export function JsonLd({
  data
}: JsonLdProps) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{
    __html: JSON.stringify(data).replace(/</g, '\\u003c')
  }} data-id="element-3505" data-mp="1pnd3yqwz0p5f" />;
}
export function getSiteUrl(path = ''): string {
  const base = typeof window === 'undefined' ? 'https://206gravel.com' : window.location.origin;
  return `${base}${path.startsWith('/') || !path ? path : `/${path}`}`;
}
function getCanonicalUrl(path?: string): string {
  if (path) return getSiteUrl(path);
  if (typeof window === 'undefined') return getSiteUrl('/');
  return `${window.location.origin}${window.location.pathname}`;
}
function setMetaTag(name: string, content: string, attribute: 'name' | 'property' = 'name') {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.content = content;
}
function setCanonical(href: string) {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.rel = 'canonical';
    document.head.appendChild(element);
  }
  element.href = href;
}